import { render, staticRenderFns } from "./MembershipCommissions.vue?vue&type=template&id=1280d5ac"
import script from "./MembershipCommissions.vue?vue&type=script&lang=js"
export * from "./MembershipCommissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports